import React, { useState } from 'react'
import PhoneInputMasked from '../../phoneInputMasked'
import { PhoneValidation } from '../../../phoneValidation'
import axios from 'axios'
import { eventEmitter } from '../../../common/baseData'

function TradeInRequest (props) {
  const [showCommentBlock, setShowCommentBlock] = useState(false)
  const [showCityDropdown, setShowCityDropdown] = useState(false)
  const [validate, setValidate] = useState(false)

  const config = {
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'X-Bitrix-Csrf-Token': props.sessid }
  }

  function onSubmit (event) {
    event.preventDefault()
    // validate
    if (!props.requestFormData.name.length || !props.requestFormData.city.length || !PhoneValidation.getInstance().validatePhone(props.requestFormData.phone)) {
      setValidate(true)
      return
    }

    // Формируем данные для отправки
    const requestData = {
      ex_product_id: Number(props.exchangeProduct.product_id),
      ex_product_price: Number(props.exchangeProduct.price),
      name: props.requestFormData.name,
      phone: props.requestFormData.phone,
      city: props.requestFormData.city,
      comment: props.requestFormData.comment,
    };

    // добавляем данные о товаре для покупки только если он есть (режим обмена)
    if (props.buyProduct) {
      requestData.buy_product_id = Number(props.buyProduct.product_id);
      requestData.buy_product_price = Number(props.buyProduct.price);

      // добавляем поле `merchant` только если оно есть
      if (props.buyProduct.merchant) {
        requestData.merchant = props.buyProduct.merchant;
      }
    } else {
      // в режиме продажи устанавливаем значения по умолчанию
      requestData.buy_product_id = 0;
      requestData.buy_product_price = 0;
    }

    eventEmitter.emit('showLoader')

    axios.post(props.request_url, requestData, config)
      .then(response => {
        eventEmitter.emit('hideLoader')
        props.setTradeinRequestData(response.data)
      })
      .catch(reason => {
        eventEmitter.emit('hideLoader')
        console.error(reason)
      })
  }

  const shosCityList = <>
    <div className="select-input-dropdown" style={{ width: '100%' }}>
      {
        Array.isArray(props.shopsCities) && props.shopsCities.length ?
          props.shopsCities.map(city => {
            return <div key={city}
                        className={props.requestFormData.city === city ? 'checked' : ''}
                        onClick={() => {
                          props.setRequestFormData({ ...props.requestFormData, city: city })
                          setShowCityDropdown(false)
                        }}>{city}</div>
          }) :
          <></>
      }
    </div>
  </>

  return (
    <form className="trade-in-content">
      <div className="trade-in-content__title">{props.getMessage('thirdSectionTitle')}</div>
      <div className={`add-comment-box ${showCommentBlock ? 'opened' : ''}`}>
        <div className="add-comment-box__title" onClick={() => (setShowCommentBlock(!showCommentBlock))}>
          {props.getMessage('addComment')}
        </div>
        <div className="add-comment-box__textarea">
          <textarea name="add-comment" id="add-comment__textarea" value={props.requestFormData.comment}
                    className={props.requestFormData.comment.length ? 'has-value' : ''}
                    onChange={event => (props.setRequestFormData({ ...props.requestFormData, comment: event.target.value }))}/>
          <span className="textarea-label">{props.getMessage('addCommentLabel')}</span>
        </div>
      </div>
      <div className="trade-in-callback-fields">
        { props.buyProduct && props.buyProduct.merchant && (
          <input type="hidden" name="merchant" value={props.requestFormData.merchant} />
        )}

        <div className={`callback-fields-input-holder`}>
          <input type="text" name="name"
                 className={`callback-input ${props.requestFormData.name.length ? 'has-value' : ''} ${validate && !props.requestFormData.name.length ? 'error' : ''}`}
                 value={props.requestFormData.name}
                 onChange={event => (props.setRequestFormData({ ...props.requestFormData, name: event.target.value }))}/>
          <span className="label-select-input">{props.getMessage('nameInputLabel')}</span>
        </div>
        <div className={`callback-fields-input-holder`}>
          <div className="iti__flag iti__ua"/>
          <PhoneInputMasked
            className={`callback-input has-value ${validate && !PhoneValidation.getInstance().validatePhone(props.requestFormData.phone) ? 'error' : ''}`}
            name="phone"
            onChange={event => {
              // Удаляем все символы кроме цифр и знака +
              let phone = '+'.concat(event.target.value.replace(/\D/g, ''))
              props.setRequestFormData({ ...props.requestFormData, phone: phone })
            }}
            value={props.requestFormData.phone}
            mask="+380(99)-999-99-99"/>
          <span className="label-select-input">{props.getMessage('phoneInputLabel')}</span>
        </div>
        <div className={`callback-fields-input-holder ${showCityDropdown ? 'show-select' : ''}`}>
          <input type="text" name="city"
                 onClick={() => (setShowCityDropdown(!showCityDropdown))}
                 className={`callback-input select ${props.requestFormData.city.length ? 'has-value' : ''} ${validate && !props.requestFormData.city.length ? 'error' : ''}`}
                 value={props.requestFormData.city}
                 readOnly={true}/>
          {shosCityList}
          <label className="label-select-input">{props.getMessage('cityInputLabel')}</label>
          <div className="selectbox__arrow"></div>
        </div>
        <div className="callback-send-btn">
          <input type="submit" className="callback-input-btn" value={`${props.getMessage('sendText')}`}
                 onClick={onSubmit}/>
        </div>
      </div>
    </form>
  )
}

export default TradeInRequest